module.exports = __webpack_public_path__ + "img/intro-strip-cropped.f66ecf64.png";